import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=10084be0&scoped=true"
import script from "./TreeViewItem.vue?vue&type=script&lang=ts"
export * from "./TreeViewItem.vue?vue&type=script&lang=ts"
import style0 from "./TreeViewItem.vue?vue&type=style&index=0&id=10084be0&prod&scoped=true&lang=css"
import style1 from "./TreeViewItem.vue?vue&type=style&index=1&id=10084be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10084be0",
  null
  
)

export default component.exports